import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

import { T_D } from '../constants';
import type { TDElement } from '../types';

/** Create a TD element */
export const createTD = (children: TDElement['children'] = [createParagraph()]): TDElement => {
    return { type: T_D, children };
};
